/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ExportMcpMetadataRequestBody,
  ExportMcpMetadataRequestBody$Outbound,
  ExportMcpMetadataRequestBody$outboundSchema,
} from "../components/exportmcpmetadatarequestbody.js";

export type ExportMcpMetadataSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ExportMcpMetadataSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ExportMcpMetadataSecurity = {
  option1?: ExportMcpMetadataSecurityOption1 | undefined;
  option2?: ExportMcpMetadataSecurityOption2 | undefined;
};

export type ExportMcpMetadataRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  exportMcpMetadataRequestBody: ExportMcpMetadataRequestBody;
};

/** @internal */
export type ExportMcpMetadataSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ExportMcpMetadataSecurityOption1$outboundSchema: z.ZodMiniType<
  ExportMcpMetadataSecurityOption1$Outbound,
  ExportMcpMetadataSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function exportMcpMetadataSecurityOption1ToJSON(
  exportMcpMetadataSecurityOption1: ExportMcpMetadataSecurityOption1,
): string {
  return JSON.stringify(
    ExportMcpMetadataSecurityOption1$outboundSchema.parse(
      exportMcpMetadataSecurityOption1,
    ),
  );
}

/** @internal */
export type ExportMcpMetadataSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ExportMcpMetadataSecurityOption2$outboundSchema: z.ZodMiniType<
  ExportMcpMetadataSecurityOption2$Outbound,
  ExportMcpMetadataSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function exportMcpMetadataSecurityOption2ToJSON(
  exportMcpMetadataSecurityOption2: ExportMcpMetadataSecurityOption2,
): string {
  return JSON.stringify(
    ExportMcpMetadataSecurityOption2$outboundSchema.parse(
      exportMcpMetadataSecurityOption2,
    ),
  );
}

/** @internal */
export type ExportMcpMetadataSecurity$Outbound = {
  Option1?: ExportMcpMetadataSecurityOption1$Outbound | undefined;
  Option2?: ExportMcpMetadataSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ExportMcpMetadataSecurity$outboundSchema: z.ZodMiniType<
  ExportMcpMetadataSecurity$Outbound,
  ExportMcpMetadataSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ExportMcpMetadataSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ExportMcpMetadataSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function exportMcpMetadataSecurityToJSON(
  exportMcpMetadataSecurity: ExportMcpMetadataSecurity,
): string {
  return JSON.stringify(
    ExportMcpMetadataSecurity$outboundSchema.parse(exportMcpMetadataSecurity),
  );
}

/** @internal */
export type ExportMcpMetadataRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  ExportMcpMetadataRequestBody: ExportMcpMetadataRequestBody$Outbound;
};

/** @internal */
export const ExportMcpMetadataRequest$outboundSchema: z.ZodMiniType<
  ExportMcpMetadataRequest$Outbound,
  ExportMcpMetadataRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    exportMcpMetadataRequestBody: ExportMcpMetadataRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      exportMcpMetadataRequestBody: "ExportMcpMetadataRequestBody",
    });
  }),
);

export function exportMcpMetadataRequestToJSON(
  exportMcpMetadataRequest: ExportMcpMetadataRequest,
): string {
  return JSON.stringify(
    ExportMcpMetadataRequest$outboundSchema.parse(exportMcpMetadataRequest),
  );
}
